import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
/**Components */
import HeaderPage from '../../../components/page/header';
import BodyPage from '../../../components/page/body';
/**Hooks */
import { useQuotes } from '../../../hooks';
/** Componentes propios */
import Filter from './Filter';
/**Utilities */
import { SweetAlert } from '../../../utilities';

export const QuotesHistory = () => {
  const navigate = useNavigate();
  const { fetchQuotes, deleteQuote } = useQuotes();
  const [filterState, setFilterState] = useState({
    page: 1,
    text: '',
  });
  //DATA TABLE
  const state = {
    page: {
      title: 'Historial de cotizaciones',
      icon: 'ri-file-list-3-line',
      model: 'quotes',
      header: {
        menu: ['Cotizaciones', 'Historial'],
      },
      buttons: {
        create: false,
        edit: false,
        destroy: false,
        import: false,
        export: false,
      },
    },
    dataTable: {
      body: {
        widthAccion: '160px',
        cols: [
          {
            name: 'client_document_number',
            alias: 'Número documento',
            width: '170px',
          },
          {
            name: 'client_names',
            alias: 'Cliente',
          },
          {
            name: 'fecha_emision',
            alias: 'Fecha emisión',
            width: '120px',
          },
          {
            name: 'fecha_vencimiento',
            alias: 'Fecha vencimiento',
            width: '160px',
          },
          {
            name: 'serie',
            alias: 'Serie',
            width: '70px',
          },
          {
            name: 'numeracion',
            alias: 'Num.',
            width: '70px',
          },
          {
            name: 'total',
            alias: 'Total',
            width: '100px',
          },
          {
            name: 'state',
            alias: 'Venta?',
            width: '50px',
            play: {
              type: 'states',
              values: {
                1: 'bg-danger-subtle text-danger',
                0: 'bg-success-subtle text-success',
              },
              names: {
                0: 'Si',
                1: 'No',
              },
            },
          },
        ],
        buttons: [
          {
            name: 'print',
            tooltip: 'Ver PDF',
            text: '',
            css: 'me-3 text-danger',
            icon: 'far fa-file-pdf',
            play: {
              type: 'alls',
            },
          },
          {
            name: 'change',
            tooltip: 'Pasar a Venta',
            text: '',
            css: 'me-3 text-primary',
            icon: 'fa-regular fa-share-from-square',
            play: {
              type: 'states',
              name: 'state',
              values: {
                1: true,
                0: false,
              },
            },
          },
          {
            name: 'edit',
            tooltip: 'Editar',
            text: '',
            css: 'me-3 text-info',
            icon: 'fa-regular fa-pen-to-square',
            play: {
              type: 'states',
              name: 'state',
              values: {
                1: true,
                0: false,
              },
            },
          },
          {
            name: 'delete',
            tooltip: 'Eliminar',
            text: '',
            css: 'me-3 text-danger',
            icon: 'fa-regular fa-trash-alt',
            play: {
              type: 'states',
              name: 'state',
              values: {
                1: true,
                0: false,
              },
            },
          }
        ],
      },
    },
  };

  const onClickAddResource = () => {};
  const onClickEditResource = () => {};
  const onClickDeleteResource = (row: any) => {
    SweetAlert.deleteConfirmation(
      () => handleDelete(row.id),
      handleCancelDelete,
      '¿Está seguro que desea eliminar la cotización?',
      row.serie + '-' + row.numeracion,
    );
  };

  const handleDelete = (id: string) => {
    deleteQuote(id).then((res) => {
      SweetAlert.success('Cotización eliminada correctamente');
    });
  };
  const handleCancelDelete = () => {};

  useEffect(() => {
    fetchQuotes(1, '', true);
  }, [fetchQuotes]);

  const onClickButtonPersonalizado = (row: any, name: any) => {
    switch (name) {
      case 'print':
        onClickPrint(row);
        break;
      case 'edit':
        navigate('/quotes-edit/' + row.uuid);
        break;
      case 'change':
        navigate('/quotes-change/' + row.uuid);
        break;
      case 'delete':
        onClickDeleteResource(row);
        break;
      default:
        break;
    }
  };

  const onClickPrint = (row: any) => {
    window.open(`${process.env.REACT_APP_LINK_BACKEND}/cotizacion/${row.uuid}.pdf`, '_blank');
  };

  /** METODOS DEL FILTER */
  const onChangePage = (page: number, type: string) => {
    switch (type) {
      case 'prev':
        setFilterState({ ...filterState, page: filterState.page - 1 });
        fetchQuotes(filterState.page - 1, filterState.text, true);
        break;

      case 'current':
        setFilterState({ ...filterState, page: page });
        fetchQuotes(page, filterState.text, true);
        break;
      case 'next':
        setFilterState({ ...filterState, page: filterState.page + 1 });
        fetchQuotes(filterState.page + 1, filterState.text, true);
        break;
      default:
        break;
    }
  };
  const onClearFilters = () => {
    setFilterState({ ...filterState, page: 1, text: '' });
    fetchQuotes(1, '', true);
  };

  const handleFilterChange = (newFilters: any, type: string) => {
    let state = true;
    if (type === 'TEXT') {
      state = false;
    }
    setFilterState(newFilters);
    fetchQuotes(1, newFilters.text, state);
  };

  return (
    <div className="main-body p-0">
      <div className="inner-wrapper">
        <div className="inner-main">
          <HeaderPage page={state.page} onModalResource={onClickAddResource} />
          <div className="inner-main-body">
            <div className="card card-featured card-featured-primary mb-3 mt-3">
              <div className="card-body">
                <Filter onClearFilters={onClearFilters} filterState={filterState} onFilterChange={handleFilterChange} />
                <BodyPage
                  onClickButtonPersonalizado={onClickButtonPersonalizado}
                  onChangeEdit={onClickEditResource}
                  onChangeDelete={onClickDeleteResource}
                  onChangePage={onChangePage}
                  page={state.page}
                  table={state.dataTable}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotesHistory;
